import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["tab", "panel"]

  connect() {
    this.show("active")
  }

  select(event) {
    event.preventDefault()
    this.show(event.currentTarget.dataset.tab)
  }

  show(selectedTab) {
    for (const tab of this.tabTargets) {
      const isSelected = tab.dataset.tab === selectedTab
      tab.classList.toggle("cp-schedule-tabs__tab--active", isSelected)
      tab.setAttribute("aria-selected", isSelected)
    }

    for (const panel of this.panelTargets) {
      panel.hidden = panel.dataset.tab !== selectedTab
    }
  }
}
